import reducer from "./reducer";
export { default as CommunicationClassification } from "./components/index";
export { default as communicationClassificationReducerName } from "./constants";
export default reducer;
